import React from 'react';

import { SyncLoader } from 'react-spinners';
const Loader = () => {
  return (
    <div className="spinner-container">
      <SyncLoader color="#36d7b7" />
    </div>
  );
};

export default Loader;
